module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_WoodMatted_MockedUp.8ba5c3d3.jpg";